import React, { useEffect, useState } from "react";

import styled from "styled-components/macro";

import FnrButton from "UI/FnrButton3";
import { useKeepOpenList } from "UI/FnrPopover2";

import { usePaymentMethod } from "../PaymentMethodContext";

import { QuickControlButton } from "./";

export default function DefaultCardButton({
  disabled = false,
  savePaymentMethod,
}) {
  const [loading, setLoading] = useState(false);
  const { isDefaultPaymentMethod = false, paymentType } =
    usePaymentMethod().state;

  const isBank = paymentType === "bank";

  const { addReason, removeReason, showing, showPopover, hidePopover } =
    useKeepOpenList();

  useEffect(() => {
    !showing && setLoading(false);
  }, [showing]);

  const handleClick = () => {
    setLoading(true);
    addReason("is_saving");
    savePaymentMethod({ isDefaultPaymentMethod: true }, () => {
      removeReason("is_saving");
      hidePopover();
    });
  };

  return (
    <QuickControlButton
      icon={(isDefaultPaymentMethod ? "fas" : "far") + " fa-star"}
      text="Default"
      onButtonClick={showPopover}
      showPopover={showing}
      attemptClosePopover={hidePopover}
      disabled={disabled}
    >
      <Wrapper>
        {isDefaultPaymentMethod && !loading ? (
          <>
            {"When you make a gift, we'll use this payment method by default."}
            <Subtext>
              You can click the star on another payment method to make it your
              default.
            </Subtext>
          </>
        ) : (
          <>
            {`Would you like to make this ${
              isBank ? "account" : "card"
            } your default payment method?`}
            <ButtonHolder>
              <FnrButton color="blue" onClick={handleClick} loading={loading}>
                Make Default
              </FnrButton>
            </ButtonHolder>
          </>
        )}
      </Wrapper>
    </QuickControlButton>
  );
}

const Wrapper = styled.div`
  padding: 12px;
  max-width: 200px;
  line-height: 1.3em;
`;
const Subtext = styled.div`
  font-size: 14px;
  line-height: 1.3em;
  margin-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.5);
  padding-top: 12px;
`;

const ButtonHolder = styled.div`
  margin-top: 12px;
`;
